import html2pdf from 'html2pdf.js';

export const Downloads = {
    GeneratePDF(element, fileName, orientation, isLoading) {
        if (!orientation) {
            orientation = 'portrait'
        }
        const originalZoom = document.body.style.zoom;
        document.body.style.zoom = '1';
        html2pdf()
            .from(element)
            .set({
                margin: [0.5, 0.5, 0.5, 0.5],
                filename: fileName,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'a4', orientation: orientation },
            })
            .save()
            .finally(() => {
                // Restore the original zoom
                document.body.style.zoom = originalZoom;
                isLoading(false);
            });
    },
    async GetBase64Image(imageUrl) {
        try {
            // Fetch the image as a Blob
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            // Convert the Blob to a Base64 string
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result;
                    resolve(base64);
                };
                
                reader.onerror = (error) => {
                    console.error("FileReader error:", error);
                    reject(new Error("Failed to read image data"));
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error converting image to Base64:", error);
            throw error;
        }
    }
}